export default __webpack_public_path__ + "static/media/segmentation-dimensions.879ace5d.png";